import { render, staticRenderFns } from "./MobileExpenseCard.vue?vue&type=template&id=5471d482&scoped=true&"
import script from "./MobileExpenseCard.vue?vue&type=script&lang=js&"
export * from "./MobileExpenseCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileExpenseCard.vue?vue&type=style&index=0&id=5471d482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471d482",
  null
  
)

export default component.exports